module.exports = __webpack_public_path__ + "img/calendar-bg-fill.4d674437.png";